import { render, staticRenderFns } from "./ContentEditor.vue?vue&type=template&id=25906e4b&scoped=true"
import script from "./ContentEditor.vue?vue&type=script&lang=js"
export * from "./ContentEditor.vue?vue&type=script&lang=js"
import style0 from "./ContentEditor.vue?vue&type=style&index=0&id=25906e4b&prod&lang=scss"
import style1 from "./ContentEditor.vue?vue&type=style&index=1&id=25906e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25906e4b",
  null
  
)

export default component.exports